export * from '@lexical/react/LexicalAutoFocusPlugin'
